"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var Node_1 = __importDefault(require("./Node"));

var Expression_1 = __importDefault(require("./Expression"));

var Variable_1 = __importDefault(require("./Variable"));

var Program =
/** @class */
function (_super) {
  __extends(Program, _super);

  function Program() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.children = [];
    return _this;
  }

  Program.prototype.parse = function () {
    while (this.tokenizer.remainingTokens() > 0) {
      var starter = this.tokenizer.getNext();
      var isExport = false;
      var child = void 0;

      if (starter === "export") {
        isExport = true;
        this.tokenizer.pop();
        starter = this.tokenizer.getNext();
      }

      if (starter === "var") {
        child = new Variable_1["default"](this.tokenizer);
      } else {
        child = new Expression_1["default"](this.tokenizer);
      }

      child.parse();
      this.children.push([child, isExport]);
      this.tokenizer.checkNextAndPop(";");
    }
  };

  Program.prototype.typeCheck = function () {
    this.children.forEach(function (_a) {
      var node = _a[0];
      return node.typeCheck();
    });
  };

  Program.prototype.evaluate = function () {
    var exports = [];
    this.children.forEach(function (_a) {
      var node = _a[0],
          isExport = _a[1];
      var colourChisel = node.evaluate();

      if (isExport) {
        exports.push(colourChisel);
      }
    });
    return exports;
  };

  return Program;
}(Node_1["default"]);

exports["default"] = Program;